import {
  LocationExternal,
  Point3D,
  ShapeExternal,
  ShapeGroupExternal,
  ShapeLayerExternalObjectless,
  VectorTaggingShapeType,
} from './shape-typings';

export const pointCloudShapeTypes = ['cuboid', 'line', 'polygon'] as const;
export const pointCloudOrthographicShapeTypes = ['line', 'polygon'] as const;

export type PointCloudShapeType = (typeof pointCloudShapeTypes)[number];
export type PointCloudOrthographicShapeType =
  (typeof pointCloudOrthographicShapeTypes)[number];
export type PointCloudAnswer =
  | NonBlankPointCloudAnswer
  | StrictRecord<string, never>;
export type PointCloudShapeGroupExternal = ShapeGroupExternal<
  Point3D,
  PointCloudShapeType
>;

export function isOrthographicShapeGroupExternal(
  group: ShapeGroupExternal<
    Point3D,
    PointCloudShapeType | VectorTaggingShapeType
  >,
): group is ShapeGroupExternal<Point3D, PointCloudOrthographicShapeType> {
  return group.shapes.some((shape) =>
    pointCloudOrthographicShapeTypes.includes(
      shape.type as PointCloudOrthographicShapeType,
    ),
  );
}

export type PointCloudShapeExternal = ShapeExternal<
  Point3D,
  PointCloudShapeType
>;
export type PointCloudLocation = LocationExternal<Point3D>;
export type NonBlankPointCloudAnswer = ShapeLayerExternalObjectless<
  Point3D,
  PointCloudShapeType
>;
